import React, { Component } from "react";

import { Link } from "react-router-dom";

class TravelRequestCreateStep5 extends Component {
  renderStep(no, title, status, active, completed) {
    return (
      <div style={stepItem}>
        <div
          style={{
            ...stepCircle,
            background: completed ? "#10B981" : active ? "#1464E9" : "#E5E7EB",
            color: completed || active ? "#fff" : "#64748B",
          }}
        >
          {completed ? "✓" : no}
        </div>
        <div>
          <div style={{ fontWeight: 800 }}>{title}</div>
          <div style={{ fontSize: 12, color: "#64748B" }}>{status}</div>
        </div>
      </div>
    );
  }

  renderInfo(label, value) {
    return (
      <div style={{ marginBottom: 14 }}>
        <div style={infoLabel}>{label}</div>
        <div style={infoValue}>{value}</div>
      </div>
    );
  }

  renderSection(title, children) {
    return (
      <div style={card}>
        <h4 style={sectionTitle}>{title}</h4>
        {children}
      </div>
    );
  }

  render() {
    return (
      <div style={{ padding: 24 }}>
        <h3 style={{ margin: 0, fontWeight: 900 }}>Create Travel Request</h3>
        <p style={sub}>Step 5 of 5 · Review & Submit</p>

        <div style={stepWrapper}>
          {this.renderStep(1, "Traveler", "Done", false, true)}
          {this.renderStep(2, "Schedule", "Done", false, true)}
          {this.renderStep(3, "Cash Advance", "Done", false, true)}
          {this.renderStep(4, "Documents", "Done", false, true)}
          {this.renderStep(5, "Review", "In Progress", true, false)}
        </div>

        <div style={layout}>
          <div>
            {this.renderSection(
              "Traveler & Trip Details",
              <div style={grid2}>
                {this.renderInfo("Name", "ALLISTAIR LORENZO JAMES")}
                {this.renderInfo("Title", "CRM EXECUTIVE")}
                {this.renderInfo("Reporting Manager", "DYLAN REDAS NOEL")}
                {this.renderInfo("Project Code", "Digitalization of BESarawak & Industry")}
                {this.renderInfo("Departure Date", "19/04/2023")}
                {this.renderInfo("Return Date", "01/05/2023")}
                {this.renderInfo("Destination", "Houston, USA")}
                {this.renderInfo("Transportation Mode", "Air")}
                <div style={{ gridColumn: "1 / span 2" }}>
                  {this.renderInfo(
                    "Trip Purpose",
                    "To attend the Simpleview Summit 2023 in Houston, Texas from 23rd - 26th April."
                  )}
                </div>
              </div>
            )}

            {this.renderSection(
              "Schedule & Accommodation",
              <div>
                <table style={table}>
                  <thead>
                    <tr style={theadRow}>
                      <th style={th}>Date</th>
                      <th style={th}>Time</th>
                      <th style={th}>Schedule</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ["19/04/2023", "06:50 - 08:40", "Depart from Kuching to Kuala Lumpur"],
                      ["20/04/2023", "10:25", "Depart from Haneda Airport to Houston"],
                      ["23/04/2023", "AM / PM", "Attend Simpleview Summit Day 01"],
                      ["24/04/2023", "AM / PM", "Attend Simpleview Summit Day 02"],
                      ["26/04/2023", "AM / PM", "Attend Simpleview Summit Day 04"],
                      ["01/05/2023", "07:30 - 09:20", "Return to Kuching"],
                    ].map((row, i) => (
                      <tr key={i} style={tr}>
                        <td style={td}>{row[0]}</td>
                        <td style={td}>{row[1]}</td>
                        <td style={td}>{row[2]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div style={{ ...grid2, marginTop: 18 }}>
                  {this.renderInfo("Preferred Hotel", "Cambria Hotel Houston Downtown Convention Center")}
                  {this.renderInfo("No. of Nights", "7 Nights")}
                  {this.renderInfo("Annual Leave", "Yes")}
                  {this.renderInfo("Leave Dates", "28/04/2023 - 29/04/2023")}
                </div>
              </div>
            )}

            {this.renderSection(
              "Cash Advance Request",
              <div>
                <div style={grid2}>
                  {this.renderInfo("Corporate Credit Card Provided", "No")}
                  {this.renderInfo("Cash Advance Required", "Yes")}
                  {this.renderInfo("Travel Type", "International Travel")}
                  {this.renderInfo("Reason", "Transportation and meals during the summit.")}
                </div>

                <table style={{ ...table, marginTop: 12 }}>
                  <thead>
                    <tr style={theadRow}>
                      <th style={th}>Description</th>
                      <th style={{ ...th, textAlign: "right" }}>Foreign Currency (USD)</th>
                      <th style={{ ...th, textAlign: "right" }}>Amount (RM)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      ["Anticipated Meal Expense / Meals", "650.00", "3,000.00"],
                      ["Other Advances", "850.00", "3,900.00"],
                      ["Foreign Currency", "450.00", "2,070.00"],
                    ].map((row) => (
                      <tr key={row[0]} style={tr}>
                        <td style={td}>{row[0]}</td>
                        <td style={{ ...td, textAlign: "right" }}>{row[1]}</td>
                        <td style={{ ...td, textAlign: "right" }}>{row[2]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div style={totalBar}>
                  <span>Total Cash Advance</span>
                  <span>RM 8,970.00</span>
                </div>
              </div>
            )}

            {this.renderSection(
              "Uploaded Documents",
              <div>
                {[
                  "Event_Invitation_Simpleview_Summit_2023.pdf",
                  "Travel_Itinerary_Draft.pdf",
                  "Hotel_Quotation_Cambria_Houston.pdf",
                  "Supporting_Purpose_Document.docx",
                  "Passport_Copy_Allistair_Lorenzo_James.pdf",
                ].map((file) => (
                  <div key={file} style={fileRow}>
                    <span>{file}</span>
                    <button style={smallButton}>View</button>
                  </div>
                ))}
              </div>
            )}

            <div style={card}>
              <label style={{ display: "flex", gap: 10, color: "#334155", fontSize: 13 }}>
                <input type="checkbox" defaultChecked />
                I confirm that the information provided is accurate and the request complies with the company travel policy.
              </label>
            </div>
          </div>

          <div>
            <div style={summaryCard}>
              <h4 style={sectionTitle}>Submission Summary</h4>
              {this.renderInfo("Request Type", "International Travel")}
              {this.renderInfo("Destination", "Houston, USA")}
              {this.renderInfo("Travel Duration", "13 Days / 11 Nights")}
              {this.renderInfo("Cash Advance", "RM 8,970.00")}
              {this.renderInfo("Document Status", "5 uploaded")}
              <div style={statusBox}>Ready to Submit</div>
            </div>

            <div style={card}>
              <h4 style={sectionTitle}>Approval Route</h4>
              {this.renderApproval("1", "Manager / Supervisor", "Dylan Redas Noel")}
              {this.renderApproval("2", "General Manager", "Pending assignment")}
              {this.renderApproval("3", "Admin / CBTA", "Booking arrangement")}
              {this.renderApproval("4", "Finance", "Payment processing")}
            </div>

            <div style={{ ...card, background: "#EAF3FF", borderColor: "#BFDBFE" }}>
              <h4 style={sectionTitle}>Next Step</h4>
              <p style={{ color: "#334155", fontSize: 13, lineHeight: "22px" }}>
                Once submitted, this request will be routed to the reporting manager for approval.
                Admin and Finance will proceed only after approval is completed.
              </p>
            </div>
          </div>
        </div>

        <div style={footer}>
          <Link to="/travel/create/step-4" style={secondaryButtonLink}>
            ← Back
          </Link>
          <div style={{ display: "flex", gap: 10 }}>
            <button style={btnOutline}>Save Draft</button>
            <button style={btnPrimary}>Submit Request</button>
          </div>
        </div>
      </div>
    );
  }

  renderApproval(no, role, name) {
    return (
      <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
        <div style={approvalCircle}>{no}</div>
        <div>
          <div style={{ fontWeight: 900, color: "#0F172A" }}>{role}</div>
          <div style={{ fontSize: 12, color: "#64748B", marginTop: 3 }}>{name}</div>
        </div>
      </div>
    );
  }
}

const sub = {
  color: "#64748B",
  fontSize: 13,
};

const layout = {
  display: "grid",
  gridTemplateColumns: "2fr 1fr",
  gap: 20,
};

const stepWrapper = {
  display: "flex",
  gap: 12,
  background: "#fff",
  padding: 16,
  borderRadius: 10,
  border: "1px solid #E5E7EB",
  margin: "20px 0",
};

const stepItem = {
  display: "flex",
  gap: 10,
  alignItems: "center",
  flex: 1,
};

const stepCircle = {
  width: 32,
  height: 32,
  borderRadius: "50%",
  textAlign: "center",
  lineHeight: "32px",
  fontWeight: 800,
};

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 10,
  padding: 18,
  marginBottom: 16,
};

const summaryCard = {
  ...card,
  borderTop: "4px solid #1464E9",
};

const sectionTitle = {
  margin: "0 0 16px",
  color: "#0F172A",
  fontWeight: 900,
};

const grid2 = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "4px 18px",
};

const infoLabel = {
  fontSize: 12,
  color: "#64748B",
  fontWeight: 800,
};

const infoValue = {
  marginTop: 4,
  fontSize: 13,
  color: "#0F172A",
  fontWeight: 800,
  lineHeight: "20px",
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
};

const theadRow = {
  background: "#F8FAFC",
};

const th = {
  padding: "10px 12px",
  textAlign: "left",
  fontSize: 12,
  color: "#334155",
  fontWeight: 900,
};

const tr = {
  borderTop: "1px solid #E5E7EB",
};

const td = {
  padding: "11px 12px",
  fontSize: 13,
  color: "#334155",
};

const totalBar = {
  marginTop: 14,
  background: "#F8FAFC",
  borderRadius: 8,
  padding: 14,
  display: "flex",
  justifyContent: "space-between",
  fontWeight: 900,
};

const fileRow = {
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "11px 12px",
  marginBottom: 8,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: 13,
  fontWeight: 700,
};

const smallButton = {
  border: "1px solid #CBD5E1",
  background: "#fff",
  borderRadius: 6,
  padding: "6px 10px",
  fontSize: 12,
};

const statusBox = {
  background: "#ECFDF3",
  color: "#027A48",
  padding: "10px 12px",
  borderRadius: 8,
  fontWeight: 900,
  textAlign: "center",
  marginTop: 16,
};

const approvalCircle = {
  width: 28,
  height: 28,
  borderRadius: "50%",
  background: "#1464E9",
  color: "#fff",
  textAlign: "center",
  lineHeight: "28px",
  fontWeight: 900,
};

const footer = {
  marginTop: 20,
  display: "flex",
  justifyContent: "space-between",
};

const btnPrimary = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "11px 24px",
  fontWeight: 900,
};

const btnOutline = {
  border: "1px solid #CBD5E1",
  background: "#fff",
  color: "#334155",
  borderRadius: 8,
  padding: "11px 24px",
  fontWeight: 800,
};

const primaryButton = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "12px 28px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "11px 24px",
  fontWeight: 800,
};

const secondaryButtonLink = {
  ...secondaryButton,
  textDecoration: "none",
  display: "inline-block",
};

export default TravelRequestCreateStep5;